import logo from '@/assets/logo.svg';

export function Logo() {
  return <img src={logo} alt="MAS Medical Staffing" width={183} height={56} />;
}
